import { all } from 'redux-saga/effects';
import { watcherLoginSaga } from './post_login';
import { watcherRegistrationSaga } from './post_registration';
import { watcherShortRegistrationSaga } from './post_shortRegistration';
import { watcherSavedVersionsSaga } from './get_versions';
import { watcherUserReportSaga } from './get_userReport';
import { watcherModulesListSaga } from './get_modulesList';
import { watcherAuthUserSaga } from './post_auth';
import { watcherLogoutSaga } from './post_logout';
import { watcherMessagesListSaga } from './get_messagesList';
import { watcherMessagesSentListSaga } from './get_messagesSentList';
import { watcherMessageContentSaga } from './get_messageContent';
import { watcherMessageDeleteSaga } from './delete_messageDelete';
import { watcherAddProgramSaga } from './post_addProjectCode';
import { watcherAddUserSaga } from './post_addUser';
import { watcherDeleteUserSaga } from './delete_deleteUser';
import { watcherAddTeamLeaderSaga } from './post_addTeamLeader';
import { watcherConnectedUsersSaga } from './get_connectedUsers';
import { watcherMessageSendSaga } from './post_messageSend';
import { watcherPrintReportSaga } from './post_printReport';
import { watcherGetTeamMembersSaga } from './get_teamMembers';
import { watcherForgottenPasswordSaga } from './post_forgottenPassword';
import { watcherSaveVersionSaga } from './post_version';
import { watcherUpdateMessageStatusSaga } from './put_updateMessageStatus';
import { watcherGetClientBackGroundSaga } from './get_clientBackGround';
import { watcherGetTeamMembersFullSaga } from './get_getTeamMembersFull';
import { watcherGetUserProgramsFullSaga } from './get_getUserProgramsFull';
import { watcherGetUserReportSaga } from './get_getUserReport';
import { watcherXapiSaga } from './post_xapi';
import { watcherAddComponentStatusSaga } from './post_addComponentStatus';
import { watcherVersionSaga } from './put_version';
import { watcherTutorialSaga } from './get_tutorial';
import { watcherDontShowTutorialSaga } from './post_dontShowTutorial';
import { watcherDropdownsSaga } from './get_dropdowns';
import { watcherCheckCodeSaga } from './checkCode';
import { watcherDeactivateSaga } from './deactivate';
import { watcherAssignmentRequestSaga } from './assignmentRequest';
import { watcherAnnouncementsSaga } from './announcements';

import { watcherSaveAnnotationSaga } from './post_saveannotations';
import { watcherSystemSaga } from './get_system';
import { watcherUpdateProfileSaga } from './post_updateProfile';
import { watcherUserRatingSaga } from './post_userrating';
import { watcherVersionStatusSaga } from './post_versionStatus';
import { watcherUpdateAnnouncementStatusSaga } from './put_updateAnnouncementStatus'
import { watcherPWASaga } from './PWAupdate'
import { watcherCheckDownloadSaga} from './checkDownload'
import { watcherCheckUploadSaga } from './checkUpload';
import { watcherContentListSaga } from './get_contentList';
import { watcherContentItemSaga } from './get_contentItem';
import { watcherToolsListSaga } from './get_toolsList';
import { watcherAssessmentsListSaga } from './get_assessmentList';
import { watcherWebinarsListSaga } from './get_webinarList';
import { watcherRegistrationPage1Saga } from './post_registration_page1';
import { watcherRegistrationPage2Saga } from './post_registration_page2';
import { watcherRegistrationPage3Saga } from './post_registration_page3';
import { watcherLoginAdminSaga } from './post_loginAdmin';
import { watcherAuthAdminSaga } from './post_authAdmin';
import { watcherPopiSaga } from './popi';
import { watcherTurnitinEulaSaga } from './post_turnitin_eula';
import { watcherTurnitinGenerateSaga } from './post_turnitin_generate';
import { watcherTurnitinUploadSaga } from './post_turnitin_upload';
import { watcherTurnitinReportSaga } from './post_turnitin_report';
import { watcherTurnitinRequestSaga } from './post_turnitin_requestSubmission';
import { watcherTurnitinLinkSaga } from './post_turnitin_link';
import { watcherAssignmentSubmitSaga } from './submitRequest';
import { watcherSaveBookmarkSaga } from './post_savebookmarks';
import { watcherTurnitinGetEulaSaga } from './post_turnitin_get_eula';
 
export default function* rootSaga() {
  yield all([
    watcherLoginSaga(),
    watcherRegistrationSaga(),
    watcherShortRegistrationSaga(),
    watcherSavedVersionsSaga(),
    watcherUserReportSaga(),
    watcherModulesListSaga(),
    watcherAuthUserSaga(),
    watcherLogoutSaga(),
    watcherMessagesListSaga(),
    watcherMessagesSentListSaga(),
    watcherMessageContentSaga(),
    watcherMessageDeleteSaga(),
    watcherAddProgramSaga(),
    watcherAddUserSaga(),
    watcherDeleteUserSaga(),
    watcherAddTeamLeaderSaga(),
    watcherConnectedUsersSaga(),
    watcherMessageSendSaga(),
    watcherPrintReportSaga(),
    watcherGetTeamMembersSaga(),
    watcherForgottenPasswordSaga(),
    watcherSaveVersionSaga(),
    watcherUpdateMessageStatusSaga(),
    watcherGetClientBackGroundSaga(),
    watcherGetTeamMembersFullSaga(),
    watcherGetUserProgramsFullSaga(),
    watcherGetUserReportSaga(),
    watcherXapiSaga(),
    watcherAddComponentStatusSaga(),
    watcherVersionSaga(),
    watcherTutorialSaga(),
    watcherDontShowTutorialSaga(),
    watcherDropdownsSaga(),
    watcherAssignmentRequestSaga(),
    watcherCheckCodeSaga(),
    watcherDeactivateSaga(),
    watcherAnnouncementsSaga(),
    watcherSystemSaga(),
    watcherSaveAnnotationSaga(),
    watcherUpdateProfileSaga(),
    watcherUserRatingSaga(),
    watcherVersionStatusSaga(),
    watcherUpdateAnnouncementStatusSaga(),
    watcherPWASaga(),
    watcherCheckDownloadSaga(),
    watcherCheckUploadSaga(),
    watcherContentListSaga(),
    watcherContentItemSaga(),
    watcherToolsListSaga(),
    watcherAssessmentsListSaga(),
    watcherWebinarsListSaga(),
    watcherRegistrationPage1Saga(),
    watcherRegistrationPage2Saga(),
    watcherRegistrationPage3Saga(),
    watcherLoginAdminSaga(),
    watcherAuthAdminSaga(),
    watcherPopiSaga(),
    watcherTurnitinEulaSaga(),
    watcherTurnitinGenerateSaga(),
    watcherTurnitinUploadSaga(),
    watcherTurnitinReportSaga(),
    watcherTurnitinRequestSaga(),
    watcherTurnitinLinkSaga(),
    watcherAssignmentSubmitSaga(),
    watcherSaveBookmarkSaga(),
    watcherTurnitinGetEulaSaga()
  ]);
}
